import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { ProfilePreviewLoaderEffects } from './+state/profile-preview-loader.effects';

// @dynamic
@NgModule({
  imports: [EffectsModule.forFeature([ProfilePreviewLoaderEffects])]
})
export class ProfilePreviewLazyLoaderModule {}
